const API_BASE = process.env.REACT_APP_API_URL || '';

const COLORS = ['#e94560', '#3b82f6', '#10b981', '#f59e0b', '#8b5cf6', '#ec4899'];

const getColor = (name = '') => COLORS[name.charCodeAt(0) % COLORS.length];

const getInitials = (name = '') =>
  name.split(' ').slice(0, 2).map(w => w[0]).join('').toUpperCase();

export default function Avatar({ src, name = '', size = 'md', className = '', style = {} }) {
  const sizeClass = `avatar avatar-${size}`;
  const imgSrc = src?.startsWith('/uploads') ? `${API_BASE}${src}` : src;

  if (imgSrc) {
    return (
      <img
        src={imgSrc}
        alt={name}
        className={`${sizeClass} ${className}`}
        style={style}
        onError={e => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'flex'; }}
      />
    );
  }

  const sizeMap = { sm: 32, md: 44, lg: 64, xl: 96 };
  const px = sizeMap[size] || 44;

  return (
    <div
      className={`${sizeClass} ${className}`}
      style={{ background: getColor(name), color: '#fff', width: px, height: px, ...style }}
    >
      {getInitials(name) || '?'}
    </div>
  );
}
